<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ 'General.UserSettings' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-profile-component id="profile"></app-profile-component>
</ion-content>
